export const linkUrl = "https://admin.goc.com.np/api"
export const imgUrl = "https://admin.goc.com.np/"

